import { createAction } from '@reduxjs/toolkit';
import VLRegion from "../../model/vlRegion";

export const setRegion = createAction<VLRegion['id']>('SET_REGION');
